import { Check } from"lucide-react";
import { useTranslation } from "react-i18next";

export const TransferCard = ({ title, name, phone, accountNumber, address }) => {
 const { t } = useTranslation();
 const fields = [
 { label: t("Name"), value: name, bold: true },
 { label: t("Phone"), value: phone },
 ...(title ==="Transfer will be made to Owner" || title === t("Transfer will be made to Owner") ? [] : [{ label: t("Account Number"), value: accountNumber, bold: true }]),
 { label: t("Address"), value: address },
 ];

 return (
 <div className="rounded-xl border border-green-200 bg-green-50 p-6">
  {/* Header */}
  <div className="flex items-center gap-3 mb-6">
  <div className="flex items-center justify-center w-7 h-7 rounded-full bg-green-600 shrink-0">
   <Check className="w-4 h-4 text-white"strokeWidth={3} />
  </div>
  <h3 className="text-base font-semibold text-green-800">{title}</h3>
  </div>

  {/* Body */}
  <div className={`grid grid-cols-1 gap-6 ${fields.length === 4 ?'md:grid-cols-2':'md:grid-cols-3'}`}>
  {fields.map((item, index) => (
   <div key={index}>
   <p className="text-xs tracking-wide text-gray-500">{item.label}</p>
   <p className={`text-gray-800 ${item.bold ?"font-medium":""}`}>
    {item.value}
   </p>
   </div>
  ))}
  </div>
 </div>
 );
};